(function(){
  function flash(btn,label){
    var old=btn.getAttribute('data-old')||btn.innerHTML;
    btn.setAttribute('data-old',old);
    btn.innerHTML='<svg class="gl-cp__i" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m4 12.5 5.2 5.2L20 7"/></svg>'+label;
    btn.classList.add('is-done');
    setTimeout(function(){ btn.innerHTML=old; btn.classList.remove('is-done'); },2200);
  }
  function copy(text,btn){
    if(navigator.clipboard&&window.isSecureContext){
      navigator.clipboard.writeText(text).then(function(){flash(btn,'コピーしました');},function(){fallback(text,btn);});
    } else { fallback(text,btn); }
  }
  function fallback(text,btn){
    var ta=document.createElement('textarea');
    ta.value=text; ta.setAttribute('readonly',''); ta.style.position='fixed'; ta.style.top='-1000px';
    document.body.appendChild(ta); ta.select();
    try{ document.execCommand('copy'); flash(btn,'コピーしました'); }
    catch(e){ window.prompt('このメールアドレスをコピーしてください', text); }
    document.body.removeChild(ta);
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-gl-copy]');
    if(!b) return;
    e.preventDefault();
    copy(b.getAttribute('data-gl-copy'),b);
  });
})();
